import script from "./PostCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostCard.vue?vue&type=script&setup=true&lang=ts"

import "./PostCard.vue?vue&type=style&index=0&id=effe9862&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-effe9862"]])

export default __exports__